import { gql } from '@apollo/client';
const CONTENT_RANGE_REGEX = /items (\d+)-(\d+)\/(\d+)/;
export const FALLBACK_PAGINATION = {
  start: 0,
  end: 0,
  total: 0
};
export const parsePagination = contentRange => {
  const matches = contentRange.match(CONTENT_RANGE_REGEX);
  if (!matches) {
    return FALLBACK_PAGINATION;
  }
  const start = parseInt(matches[1]);
  const end = parseInt(matches[2]);
  const total = parseInt(matches[3]);
  return {
    start,
    end,
    total
  };
};
export const PAGINATION_TOKEN = '__Paginated';
const paginated = doc => {
  const rootDefinition = doc.definitions[0];
  if (rootDefinition.operation !== 'query') {
    throw new Error('Only pagination of `query` is supported.');
  }
  const firstSelection = rootDefinition.selectionSet.selections[0];
  if (!firstSelection) {
    throw new Error('No selection in the query.');
  }
  const restDirective = firstSelection.directives.find(dir => dir.name.value === 'rest');
  if (!restDirective) {
    throw new Error('No @rest directive applied to the selection');
  }
  const queryName = rootDefinition.name.value;
  const variables = rootDefinition.variableDefinitions.map(def => `$${def.variable.name.value}: ${def.type.kind === 'NonNullType' ? `${def.type.type.name.value}!` : def.type.name.value}`).join(', ');
  const selectionName = firstSelection.name.value;
  const selectionArguments = firstSelection.arguments.map(arg => `${arg.name.value}: $${arg.value.name.value}`).join(', ');
  const directiveArguments = restDirective.arguments.filter(arg => arg.name.value !== 'type').map(arg => `${arg.name.value}: "${arg.value.value}"`).join(', ');
  const typeName = restDirective.arguments.find(arg => arg.name.value === 'type').value.value;
  const fields = firstSelection.selectionSet.selections.map(sel => sel.name.value).join('\n            ');
  return gql`
    query ${queryName}(${variables}, $page: Int, $page_size: Int) {
      ${selectionName}(${selectionArguments}, page: $page, page_size: $page_size)
      @rest(type: "${PAGINATION_TOKEN}${typeName}", ${directiveArguments}) {
        results @type(name: "${typeName}") {
          ${fields}
        }
        pagination @type(name: "Pagination") {
          __typename
          start
          end
          total
        }
      }
    }
  `;
};
export default paginated;